export default "__VITE_ASSET__D_ohOhDO__"